/* Listen to events outside the webcomponent to close.
   Otherwise it gets closed when clicked or focussed on the
   buttons inside this component. */
const getElementTarget = (args) => {
  return (args.active &&
    args.target != args.element &&
    /* Find the first element in this component and all slots
       that matches the target, if not find anything return true */
    !Array.from(args.element.querySelectorAll("*")).find((el) => el == args.target));
};

export { getElementTarget as g };
